// extracted by mini-css-extract-plugin
export default {"card":"HeroAbstract_card__pQ9nf","symbol":"HeroAbstract_symbol__DJbq5","notationDrift":"HeroAbstract_notationDrift__-vJoN"};